const listPointsBody = document.querySelector('#FestStreams').querySelector('div[name=body]');
// import auth from '../tools/storage.js';

const selectTimeZone = document.querySelector('#FestStreams').querySelector('select[name=listTimeZone]');
import tools from '../tools/tools.js';


export default {

  cleanContainer() {
    listPointsBody.innerHTML = '';
  },

  getElement(item, index, maxID) {
    let date = tools.strToDate(item.timeEnd);
    console.log(selectTimeZone.value);
    date = new Date(date.getTime() + (selectTimeZone.value * 60 * 60) * 1000);
    let formattedTime = `${date.getDate()} ${tools.getMonthBeforeNameX(date.getMonth()+1)} ${date.getHours()}:${date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()}`;
    // console.log(date);
    // let formattedTime = tools.dateStringFull(date);
//2021-03-17 04:00:00
    // let timeStart = item.timeStart.substring(11, 16);

    let hallName = '';
    if(item.hname)
      hallName = item.hname;
   


    let nodeData = ` streamID = ${item.id}  action=edit`;
    let classLastRow = '';
    if (parseInt(item.id, 10) == maxID)
      classLastRow = 'maxID';

    let maxViewDiv = '';

    if(item.maxView)
      maxViewDiv = `<label class="ml-3 mr-1" ${nodeData}> Макс. кол-во повторов:</label> ${item.maxView}`;


    return `<div class= " stream_cloud  ${classLastRow}" ${nodeData}> 
              
              <div class="column w-100 m-0 p-1 " ${nodeData}>
                  <b class="schedule_cloud_name m-0 p-1 txt-al-center  " ${nodeData}>
                    ${item.name} 
                  </b>
                  <div class="row schedule_cloud_link ml-auto mr-auto p-1 txt-al-right" ${nodeData}>
                    <label class="mr-1" ${nodeData}>До:</label> <b class="ml-0 mr-3" ${nodeData} > ${formattedTime} </b>
                    ${maxViewDiv}
                     
                  </div> 
                <a class=" m-0 p-1 w-100" href="${item.link}" target="_blank">${item.link}</a>
              </div>     
            </div>`;
              // <button type="delete" class = "bt_delete"  ${nodeData}></button>/

    // return `<label class="reference-header schedule-row" scheduleid="${item.id}">
    //           <div class="schedule-column" scheduleid="${item.id}">${formattedTime}</div>
    //           <div class="schedule-column" scheduleid="${item.id}">${item.name}</div>
    //           <div class="schedule-column" scheduleid="${item.id}">${item.placeName}</div>
    //         </label>`;
  },



  drawDataInContainer(enterprisesData) {
    listPointsBody.innerHTML = '';
    let maxID = 0;
    if (enterprisesData) {
      enterprisesData.forEach((item, index) => {
        if(maxID < parseInt(item.id, 10))
          maxID = parseInt(item.id, 10)
      });

      enterprisesData.forEach((item, index) => listPointsBody.insertAdjacentHTML('beforeend', this.getElement(item, index, maxID)));
    };
  },

  drawMarkupInContainer(markup) {
    listPointsBody.insertAdjacentHTML('beforeend', markup);
  }
};
